<template>
	<div>
		<Navbar />
	</div>
</template>

<script>
import Navbar from '@/components/Navbar';

export default {
	components: {
		Navbar
	},

}

</script>

<style scoped>

</style>
